export enum RevisionVersions {
  MAJOR = 'major',
  MINOR = 'minor',
  MAJOR_ONLY = 'MAJOR_ONLY',
}
